
document.addEventListener('DOMContentLoaded', function () {
  const renameCartModal = document.getElementById('renameCartModal');
  const renameCartForm = document.getElementById('renameCartForm');
  const cartIdInput = document.getElementById('cart_id');
  const cartNameInput = document.getElementById('cart_name');

  renameCartModal.addEventListener('show.bs.modal', function (event) {
    const button = event.relatedTarget; // Button that triggered the modal
    const cartId = button.getAttribute('data-cart-id'); // Extract info from data-* attributes

    console.log(`Cart ID: ${cartId}`);

    // Update the modal's content.
    cartIdInput.value = cartId;
  });

  // Handle form submission
  renameCartForm.addEventListener('submit', function (event) {
    const newCartName = cartNameInput.value;
    const nonce = document.getElementById('rename_cart_nonce').value;
    renameCartForm.action = `/my-account/saved-carts/?cart_id=${cartIdInput.value}&action=rename_cart&cart_name=${encodeURIComponent(newCartName)}&_wpnonce=${nonce}`;
  });


});


/**
 * Delete cart
 */
document.addEventListener('DOMContentLoaded', function () {
  // Select all delete links
  const deleteLinks = document.querySelectorAll('.delete-cart');

  deleteLinks.forEach(link => {
    link.addEventListener('click', function (event) {
      // Prevent default link action
      event.preventDefault();

      // Display confirmation alert
      const confirmed = confirm('Are you sure you want to delete this cart? This action cannot be undone.');

      if (confirmed) {
        // If user confirms, redirect to the link's href
        window.location.href = link.href;
      }
    });
  });
});


/**
 *  save-cart-changes
 */
document.addEventListener('DOMContentLoaded', function () {
  const saveLinks = document.querySelectorAll('.save-cart-changes');
  console.log('saveLinks', saveLinks);

  saveLinks.forEach(link => {
    link.addEventListener('click', function (event) {
      // Prevent default link action
      event.preventDefault();
      // get cart name from attribute
      const cartName = link.getAttribute('data-cart-name');
      console.log('cartName', cartName);

      // Display confirmation alert
      const confirmed = confirm(
        `Are you sure you want to save changes to the cart "${cartName}"? This action will overwrite the existing cart contents with the current cart items.`
      );

      if (confirmed) {
        // If user confirms, redirect to the link's href
        window.location.href = link.href;
      }
    });
  });
});

/**
 *  load-cart
 */
document.addEventListener('DOMContentLoaded', function () {
  const loadLinks = document.querySelectorAll('.load-cart');
  console.log('loadLinks', loadLinks);

  loadLinks.forEach(link => {
    link.addEventListener('click', function (event) {
      // Prevent default link action
      event.preventDefault();
      // get cart name from attribute
      const cartName = link.getAttribute('data-cart-name');
      console.log('cartName', cartName);

      // Display confirmation alert
      const confirmed = confirm(
        `Are you sure you want to load the cart "${cartName}"? Any unsaved changes to your current cart will be lost.`
      );

      if (confirmed) {
        // If user confirms, redirect to the link's href
        window.location.href = link.href;
      }
    });
  });
});
